import { AxiosResponse } from "axios";

export default function downloadDocument(response: AxiosResponse<Uint8Array>): void {
    // Try to get the filename from the response header
    const filename = getFilename(response);

    // Download file
    const fileBlob = new Blob([response.data]);

    const url = window.URL.createObjectURL(fileBlob);
    const link = document.createElement("a");
    link.href = url;

    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
}


function getFilename(response: AxiosResponse): string {
    let filename = null as string | null;

    try {
        const disposition = response.request.getResponseHeader("Content-Disposition");
        console.log(disposition);
        filename = disposition.split("filename=")[1].split(";")[0];
        console.log(filename);
    } catch (e) {
        console.log(e);
    }

    // Check and create new filename if no name found in header
    if (filename == null) {
        filename = "attachment"; // We do not know what the file should have as extension
    }

    return decodeURIComponent(filename.replace(/"+/g, "")) as string; // Return filname after removing " chars if exists
}